var _style, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlockImgFour(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 807 807",
    style: {
      enableBackground: "new 0 0 807 807"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:22;stroke-miterlimit:10;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 403.5,
    cy: 403.5,
    r: 392.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 687.5,
    cy: 130.5,
    r: 92.5
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M404,520.8c-9.2,0-16.7,7.5-16.7,16.7c0,9.2,7.5,16.7,16.7,16.7s16.7-7.5,16.7-16.7 C420.7,528.3,413.2,520.8,404,520.8z M404,543.2c-3.1,0-5.6-2.5-5.6-5.6c0-3.1,2.5-5.6,5.6-5.6s5.6,2.5,5.6,5.6 C409.6,540.7,407.1,543.2,404,543.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M409.6,253.1h-11.2c-3.1,0-5.6,2.5-5.6,5.6c0,3.1,2.5,5.6,5.6,5.6h11.2c3.1,0,5.6-2.5,5.6-5.6 C415.2,255.6,412.7,253.1,409.6,253.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M537.9,499.7c-17.5,0-32.3,11.9-36.7,28h-60.9c-3.6-12.9-13.7-23.1-26.6-26.7v-38.5h100.2 c33.6,0,61-27.4,61-61.1c0-32.1-24.9-58.5-56.4-60.9c-2.6-27.5-25.8-49.1-54-49.1c-5.5,0-10.9,0.8-16.1,2.4 c-1-34.9-29.7-62.9-64.7-62.9c-35.7,0-64.7,29.1-64.7,64.8v4.5h-5.8c-44.7,0-81,36.4-81,81.1s36.3,81.1,81,81.1h80.2v38.5 c-12.9,3.6-23.1,13.7-26.6,26.7h-61c-4.4-16.1-19.2-28-36.7-28c-21,0-38.1,17.1-38.1,38.1s17.1,38.1,38.1,38.1 c17.5,0,32.3-11.9,36.7-28h61c4.4,16.1,19.2,28,36.7,28s32.3-11.9,36.7-28h60.9c4.4,16.1,19.2,28,36.7,28 c21,0,38.1-17.1,38.1-38.1C576,516.8,558.9,499.7,537.9,499.7L537.9,499.7z M252.4,381.5c0-33.6,27.3-60.9,60.8-60.9h25.9v-24.7 c0-24.6,20-44.6,44.5-44.6c24.6,0,44.5,20,44.5,44.6v34.3l16.1-11.9c5.9-4.3,12.8-6.6,20.1-6.6c18.8,0,34,15.3,34,34.1 c0,1.2-0.1,2.4-0.2,3.7l-1.2,11.2h16.7c22.5,0,40.8,18.3,40.8,40.9s-18.3,40.9-40.8,40.9H313.3 C279.7,442.4,252.4,415.1,252.4,381.5L252.4,381.5z M269.1,555.8c-9.9,0-17.9-8-17.9-17.9c0-9.9,8-17.9,17.9-17.9 c9.9,0,17.9,8,17.9,17.9C287,547.7,279,555.8,269.1,555.8z M403.6,555.8c-9.9,0-17.9-8-17.9-17.9c0-9.9,8-17.9,17.9-17.9 s17.9,8,17.9,17.9C421.5,547.7,413.4,555.8,403.6,555.8z M537.9,555.8c-9.9,0-17.9-8-17.9-17.9c0-9.9,8-17.9,17.9-17.9 c9.9,0,17.9,8,17.9,17.9C555.8,547.7,547.8,555.8,537.9,555.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockImgFour);
export default __webpack_public_path__ + "static/media/block-img-four.45a79580540cfcd70da52fa2faad590f.svg";
export { ForwardRef as ReactComponent };